import ReactPlayer from "react-player";
import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardImg,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class VideoEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoUrlId: "",
      showLoader: false,
      video: props.video || {},
    };
    this.updateVideo = this.updateVideo.bind(this);
    this.createVideo = this.createVideo.bind(this);
  }

  componentDidMount() {
    if (this.state.video.video_url) {
      this.setState({
        videoUrlId: GeneralFunctions.YouTubeGetID(this.state.video.video_url),
      });
    }
  }

  createVideo = async (event) => {
    try {
      event.preventDefault();
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "/video/web/create",
        method: "POST",
        data: {
          description: this.state.video.description,
          video_url: this.state.video.video_url,
          thumbnail_url: this.state.video.thumbnail_url,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateVideo = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.serverRequest({
        url: "/video/web/update",
        method: "POST",
        data: {
          videoId: this.state.video._id,
          description: this.state.video.description,
          video_url: this.state.video.video_url,
          thumbnail_url: this.state.video.thumbnail_url,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  closeEditPage = (value) => {
    this.props.closeVideoEditPage({ refreshList: value });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={this.props.editVideoKey ? "Edit Video" : "Add Video"}
          breadcrumbs={[
            {
              name: this.props.editVideoKey ? "Edit Video" : "Add Video",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.editVideoKey
                        ? this.updateVideo
                        : this.createVideo
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="description">Description</Label>
                          <Input
                            type="textarea"
                            name="description"
                            placeholder="Description"
                            required
                            value={this.state.video.description || ""}
                            onChange={(event) =>
                              this.setState({
                                video: {
                                  ...this.state.video,
                                  description: event.target.value,
                                },
                              })
                            }
                            style={{ height: "115px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="video_url">Video Url</Label>
                          <Input
                            style={{ marginBottom: "10px" }}
                            type="text"
                            name="video_url"
                            placeholder="Video Url"
                            required
                            value={this.state.video.video_url || ""}
                            onChange={(event) =>
                              this.setState({
                                videoUrlId: GeneralFunctions.YouTubeGetID(
                                  event.target.value
                                ),
                                video: {
                                  ...this.state.video,
                                  video_url: event.target.value,
                                  thumbnail_url: `https://i1.ytimg.com/vi/${GeneralFunctions.YouTubeGetID(
                                    event.target.value
                                  )}/hqdefault.jpg`,
                                },
                              })
                            }
                          />
                          <Label for="video_url">Video Id</Label>
                          <Input disabled value={this.state.videoUrlId || ""} />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Thumbnail</Label>
                          {this.state.video.thumbnail_url ? (
                            <CardImg
                              width="100%"
                              height="340px"
                              src={this.state.video.thumbnail_url}
                              alt=""
                            />
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Video</Label>
                          {this.state.videoUrlId ? (
                            <ReactPlayer
                              width="100%"
                              height="340px"
                              controls={true}
                              url={`https://www.youtube.com/watch?v=${this.state.videoUrlId}`}
                            />
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {this.props.editVideoKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default VideoEdit;
